export const auth0_domain=process.env.REACT_APP_AUTH0_DOMAIN;
export const auth0_client_id=process.env.REACT_APP_AUTH0_CLIENT_ID;
export const auth0_audience=process.env.REACT_APP_AUTH0_AUDIENCE;